module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmYUtfCxc4EsA.bbb00ee9.woff2";